var React = require('react');

function NumberFourInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.5001 22.782C6.90002 22.782 2.34387 18.2259 2.34387 12.6258C2.34387 7.02569 6.90002 2.46954 12.5001 2.46954C18.1002 2.46954 22.6564 7.02569 22.6564 12.6258C22.6564 18.2259 18.1002 22.782 12.5001 22.782Z","fill":"#FA7360","key":0}),React.createElement("path",{"d":"M8.55877 16.1108H13.416V18H15.176V16.1108H16.4785V14.5945H15.176V7.81818H12.8791L8.55877 14.6442V16.1108ZM13.4359 14.5945H10.448V14.5149L13.3564 9.90625H13.4359V14.5945Z","fill":"white","key":1})]);
}

NumberFourInline.defaultProps = {"viewBox":"0 0 25 26","fill":"none"};

module.exports = NumberFourInline;

NumberFourInline.default = NumberFourInline;
